import { render, staticRenderFns } from "./AiResponsePlaceholder.vue?vue&type=template&id=f4f66c3c&scoped=true&"
import script from "./AiResponsePlaceholder.vue?vue&type=script&lang=ts&"
export * from "./AiResponsePlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./AiResponsePlaceholder.vue?vue&type=style&index=0&id=f4f66c3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f66c3c",
  null
  
)

export default component.exports